module.exports = __webpack_public_path__ + "img/ROME.533ebbb0.svg";